import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import './style.scss';
import TestEditorFooter from './Footer';
import { fadeInModule, saveTestName, setTestName } from '../../redux/actions';
import { Button, CustomScrollbars, Icon, ModuleHeader, ModuleTopBar } from '../../components';
import { useDidMount, useDidUpdate, useWillUnmount } from 'rooks';
import { setEditorMode } from '../../redux/actions/editor';
import { Droppable } from 'react-beautiful-dnd';
import TestEditorSingleTask from './SingleTask';
import { Scrollbars } from '../../contexts/scrollBarsContext';

function TestEditorModule({ mode }) {
	const testNameInput = useRef(null);

	const state = useSelector((state) => state);
	const dispatch = useDispatch();
	const activeTest = state.editor.test;

	const [isNameEditable, setIsNameEditable] = useState(false);

	const { setScrollbars } = Scrollbars();

	const updateMode = () => {
		dispatch(setEditorMode(mode));
	};

	const handleNameChange = (e) => {
		dispatch(setTestName(e.target.value));
	};

	const handleNameEdit = async (e) => {
		if (isNameEditable === false) {
			e.preventDefault();
			await setIsNameEditable(true);
			testNameInput.current.focus();
		}
	};

	//render test name for module TopBar
	const testName = (() => {
		if (activeTest) {
			if (activeTest.nazwa !== '') {
				return activeTest.nazwa;
			} else if (activeTest.nazwa === '' && !isNameEditable) {
				return 'Wprowadź nazwę testu';
			} else {
				return '';
			}
		} else {
			return '';
		}
	})();

	useDidMount(() => {
		// smooth render animation
		dispatch(fadeInModule('editor'));

		updateMode();
	});

	useDidUpdate(updateMode, [mode]);

	useWillUnmount(() => {
		dispatch(setEditorMode(null));
	});

	return (
		<section
			className={`module-editor ${state.editor.mobileActive ? 'mobile-active' : ''} ${
				state.editor.isHidden ? 'hidden' : ''
			} ${state.editor.mode}`}
		>
			<ModuleTopBar>
				{!!activeTest && (
					<form
						autoComplete="off"
						onSubmit={(e) => {
							e.preventDefault();
							if (isNameEditable) {
								if (activeTest['id_testu'] && activeTest['nazwa'] !== '') {
									saveTestName(activeTest['id_testu'], activeTest['nazwa']);
									setIsNameEditable(false);
								} else if (activeTest['nazwa'] !== '') {
									setIsNameEditable(false);
								} else {
									toast.error('Pole nazwy testu nie może być puste', {
										closeButton: false,
										autoClose: 2500,
										hideProgressBar: true,
									});
									testNameInput.current.focus();
								}
							}
						}}
					>
						<input
							type="text"
							id={`test-name-editor`}
							onChange={handleNameChange}
							value={testName}
							disabled={!isNameEditable}
							autoComplete="off"
							ref={testNameInput}
						/>
						{mode === 'edit' && (
							<Button onClick={handleNameEdit} color="transparent text-white">
								<span className="btn-label">
									{!isNameEditable
										? `Edytuj${!state.app.isTabletSize ? ' nazwe testu' : ''}`
										: 'Zapisz'}
								</span>
								<Icon name="pencil" width="16px" height="14px" color="#fff" />
							</Button>
						)}
					</form>
				)}
			</ModuleTopBar>
			<ModuleHeader>{/* place for group tabs */}</ModuleHeader>
			{activeTest && (
				<div
					className={`editor ${
						state.editor.mode === 'edit' || state.editor.compareMode ? 'editable' : ''
					}`}
					id="scroll-editor"
				>
					<CustomScrollbars refa={(ref) => setScrollbars(ref)} autoHide>
						<Droppable
							droppableId="group-0"
							isDropDisabled={state.app.isTabletSize || state.editor.mode === 'preview'}
						>
							{(provided) => (
								<div className="editor-group">
									<div className="editor-group-header">
										<span className="student-name">Imię i nazwisko ucznia</span>
										<span className="student-class">Klasa</span>
										<span className="test-date">Data</span>
									</div>
									<ul
										className="editor-group-taskslist"
										ref={provided.innerRef}
										{...provided.droppableProps}
									>
										{activeTest.tasks.length > 0 &&
											activeTest.tasks.map((task, index) => {
												return (
													<TestEditorSingleTask
														key={`editor-task-${task['id_pytania']}`}
														id={task['id_pytania']}
														task={task}
														index={index}
														groupID="group-0"
													/>
												);
											})}
										{activeTest.tasks.length <= 0 && (
											<div className="editor-placeholder">
												{state.app.isTabletSize
													? 'Dodaj nowe zadanie'
													: 'Dodaj lub przeciągnij zadanie'}
											</div>
										)}
										{provided.placeholder}
									</ul>
								</div>
							)}
						</Droppable>
					</CustomScrollbars>
				</div>
			)}
			{!activeTest && <p className="editor-placeholder"> Wybierz test aby wyświetlić </p>}
			{!!activeTest && <TestEditorFooter />}
		</section>
	);
}

export default TestEditorModule;
